import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';
import { UtilService } from './../../../services/util.service';

import { MatDialog } from '@angular/material/dialog';
import { NavigationStart, Router } from '@angular/router';
import dayjs from 'dayjs';
import jwt_encode from 'jwt-encode';
import moment from 'moment';
import { Observable, Subscription, interval } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Socket, io } from 'socket.io-client';
import { environment } from '../../../../environments/environment';
import { AnalyticsService, LayoutService } from '../../../@core/utils';
import { RippleService } from '../../../@core/utils/ripple.service';
import { administratorRole } from '../../../config/administator-role';
import { NOTIFICATIONS } from '../../../config/mock-data';
import { FrontendSiteType, XANO_WORKSPACE_CODE } from '../../../enum/environment_urls.enum';
import { CHANGE_TRIAL_ROLES, TRIAL_TEACHER_TEACHING_INFO } from '../../../enum/lesson-plan-privacy';
import { ROLE, ROLES } from '../../../enum/roles.enum';
import { UserActivityStatus } from '../../../enum/user-activity-status.enum';
import { ClearObservableHelper } from '../../../helpers/ClearObservableHelper';
import { STUDENT_MENU_ITEMS } from '../../../pages/pages-menu';
import { AuthService } from '../../../services/auth.service';
import { NotificationsService } from '../../../services/notifications.service';
import { SocialLoginService } from '../../../services/social-login.service';
import { StorageService } from '../../../services/storage.service';
import { StudentService } from '../../../services/student.service';
import { ToasterService } from '../../../services/toaster.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent extends ClearObservableHelper implements OnInit, OnDestroy {
  socket: Socket;
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  openSidebar = this.storageService.detectMob() ? false : true;
  user: any;
  notifications = [];
  unreadNotifications = [];
  @ViewChild('startAssessment') startAssessment: TemplateRef<any>;
  public currentAssessment: any;
  badgeVisible: boolean = false;

  mockData = this.storageService.getItem('user').user['is_trial_user'] ? true : false;
  changeTrialUserRoles = [];
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  receivedValue: string;
  currentUserRoleValue;
  private timeout: number | any;
  private lastActivity: Date;
  private statusCheckSubscription: Subscription;
  private previousActivityStatus: string = '';
  isLoggedOut: boolean = false;
  userRoles = ROLES;

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    public router: Router,
    public storageService: StorageService,
    private authService: AuthService,
    public analyticsService: AnalyticsService,
    private notificationService: NotificationsService,
    private studentService: StudentService,
    public dialog: MatDialog,
    private toasterService: ToasterService,
    private socialLoginService: SocialLoginService,
    private utilService: UtilService,
  ) {
    super();
    this.socket = io(environment.NODE_SERVER, {
      reconnection: true, // Enable reconnection logic
      reconnectionAttempts: 5, // Number of reconnection attempts
      reconnectionDelay: 1000, // Delay between reconnection attempts
    });

    // Listen for navigation events
    this.router.events.pipe(takeUntil(this.destroy$)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        // Close the socket connection before navigating away
        if (this.socket) {
          this.socket.disconnect();
          this.socket.close();
        }
      }
    });

    this.materialTheme$ = this.themeService.onThemeChange().pipe(
      map((theme) => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }),
    );

    this.authService.updateValue.subscribe(async (value: string) => {
      if (value) {
        const user = await this.storageService.getItem('user');
        this.user = await this.authService.userById(user.user.id);
      }
    });
  }

  async ngOnInit() {
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden' && !this.isLoggedOut) {
        this.checkUserStatus();
      }
    });

    this.notificationService.unreadNotificationCount.subscribe((count) => {
      this.badgeVisible = count > 0;
    });

    this.currentTheme = this.themeService.currentTheme;
    const user = await this.storageService.getItem('user');

    if (user) this.user = user.user;

    await this.connectSocket();

    const url = this.utilService.getDynamicSocketEventName('update', 'Badge');

    this.socket.on(`${url}${this.user.id}`, async () => {
      this.storageService.setItem('isUnreadNotifications', true);
      this.storageService.isBadge = true;
    });

    if (this.user?.is_trial_user) {
      // Show the correct role list for the trial users
      this.changeTrialUserRoles = this.storageService.checkUserRole(this.user.role.id, ROLE.TEACHER)
        ? CHANGE_TRIAL_ROLES.filter((x) => x.value !== 1)
        : CHANGE_TRIAL_ROLES;

      this.user.role.name = this.storageService.checkUserRole(this.user.role_id, ROLE.TEACHER)
        ? administratorRole['Teacher']
        : administratorRole['Principal'];
    }

    if (this.user?.role_id === ROLES.STUDENT) {
      this.authService.checkIfAssessmentGoingOn();
      //  socket for activating new assessment

      // if (environment.XANO_SERVER_URL.includes(XANO_WORKSPACE_CODE.STAGE_CLONE)) {
      if (this.utilService.detectFrontendSiteType() === FrontendSiteType.STAGE) {
        this.socket.on('activateNewStageAssessment', async (assessment: any) => {
          console.log('activateNewStageAssessment');

          assessment['isReactivate'] = false;
          this.startAssessmentByUsingSocketEvent(assessment);
        });
        this.socket.on('reactivateOldStageAssessment', async (assessment: any) => {
          console.log('reactivateOldStageAssessment');

          assessment['isReactivate'] = true;
          this.startAssessmentByUsingSocketEvent(assessment);
        });
      } else {
        //socket condition for dev site
        //  if (environment.XANO_SERVER_URL.includes(XANO_WORKSPACE_CODE.DEV)) {
        if (this.utilService.detectFrontendSiteType() === FrontendSiteType.DEV) {
          this.socket.on('activateNewDevAssessment', async (assessment: any) => {
            assessment['isReactivate'] = false;
            this.startAssessmentByUsingSocketEvent(assessment);
          });
          this.socket.on('reactivateOldDevAssessment', async (assessment: any) => {
            assessment['isReactivate'] = true;
            this.startAssessmentByUsingSocketEvent(assessment);
          });
        } else {
          this.socket.on('activateNewAssessment', async (assessment: any) => {
            assessment['isReactivate'] = false;
            this.startAssessmentByUsingSocketEvent(assessment);
          });
          this.socket.on('reactivateOldAssessment', async (assessment: any) => {
            assessment['isReactivate'] = true;
            this.startAssessmentByUsingSocketEvent(assessment);
          });
        }
      }
    }

    // this.socket
    //   .fromEvent('activateNewAssessment')
    //   .subscribe(async (assessment: any) => {
    //     assessment['isReactivate'] = false;
    //     this.startAssessmentByUsingSocketEvent(assessment);
    //   });

    // //  socket for reactivating old assessment
    // this.socket
    //   .fromEvent('reactivateOldAssessment')
    //   .subscribe(async (assessment: any) => {
    //     assessment['isReactivate'] = true;

    //     this.startAssessmentByUsingSocketEvent(assessment);
    //   });

    //  socket for reactivating old assessment

    await this.getNotifications();
    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService
      .onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => (this.userPictureOnly = isLessThanXl));

    this.menuService.onItemClick().subscribe(async (res) => {
      if (this.user.role_id === ROLES.STUDENT && this.getCurrentOnGoingAssessment()) {
        this.toasterService.showToast('Please finish the ongoing assessment first', 'danger');
        return;
      }

      this.analyticsService?.trackEvent(`Link Rendered`, 'Header');
      if (res.item.title === 'Log out') {
        const currentLocalUser = await this.storageService.getItem('user');
        this.authService.logout();
        this.socialLoginService.socialLogout();
        this.socket.disconnect();
        this.removeSocketObservable(currentLocalUser.user.id);
        this.router.navigateByUrl('/auth/login');
        this.storageService.clearStorage();
        // Enable side menu after logout
        this.authService.disabledSideMenu.emit(false);
        await this.updateUserLogOutSessionTime(currentLocalUser.user.id);
        //adding/editing the existing record the record to keep track of user sessions
        const activityLog = {
          user_id: currentLocalUser.user.id,
          token: currentLocalUser.authToken,
          expired_time: moment(),
        };
        await this.authService.addOrEditUserActivityLog(activityLog);
        this.updateUserStatus(UserActivityStatus.LOGGED_OUT);
        this.isLoggedOut = true;
      } else if (res.item.title === 'Profile') {
        this.router.navigateByUrl('/profile');
      } else if (res.item.title === 'Messaging') {
        this.router.navigateByUrl('/messaging');
      }
    });

    this.themeService
      .onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe((themeName) => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });

    await this.inactivityTime();
    // await this.getUserStatus();
    this.statusCheckSubscription = interval(60000).subscribe(() => this.checkUserStatus());
  }

  async connectSocket() {
    console.log(this.socket);
    this.socket.connect();
    this.socket.emit('setUserName', this.user?.id);
  }

  changeUserRoleInLocal(event) {
    try {
      if (this.currentUserRoleValue === event.value) {
        return;
      }

      this.currentUserRoleValue = event.value;
      if (event.value === CHANGE_TRIAL_ROLES[2].value) {
        this.toasterService.showToast('We are constantly working on it', 'info');
        return;
      }

      const currentUserData = this.storageService.getItem('user');

      if (event.value === CHANGE_TRIAL_ROLES[0].value) {
        currentUserData.user.teachingInfo = TRIAL_TEACHER_TEACHING_INFO;
        currentUserData.user.role_id = ROLES.EXECUTIVE_DIRECTOR;
        this.user.role.name = administratorRole['Principal'];
        this.setUserRoleAndRedirect(currentUserData, event.value);
      } else if (event.value === CHANGE_TRIAL_ROLES[1].value) {
        currentUserData.user.role_id = ROLES.TEACHER;
        this.user.role.name = administratorRole['Teacher'];

        this.setUserRoleAndRedirect(currentUserData, event.value);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  // private removeSocketObservable(userId: number): void {
  //   const url = environment.XANO_SERVER_URL.includes('rvW79E8r')
  //     ? 'updateStageBadge'
  //     : 'updateBadge';

  //   if (
  //     this.socket.eventObservables$ &&
  //     this.socket.eventObservables$.hasOwnProperty(`${url}${userId}`)
  //   ) {
  //     delete this.socket.eventObservables$[`${url}${userId}`];
  //     delete this.socket.subscribersCounter[`${url}${userId}`];
  //     delete this.socket.ioSocket._callbacks;
  //   }
  // }

  private removeSocketObservable(userId: number): void {
    const url = this.utilService.getDynamicSocketEventName('update', 'Badge');

    const eventKey = `${url}${userId}`;

    // Remove specific event listener
    this.socket.off(eventKey);

    // Optionally, remove all listeners related to the eventKey
    this.socket.removeAllListeners(eventKey);
  }

  setUserRoleAndRedirect(currentUserData, event) {
    try {
      const user = jwt_encode(currentUserData.user, 'respondedu 1234567890123456789012');

      currentUserData.user = user;

      this.storageService.setItem('user', currentUserData);

      this.toasterService.showToast('User role updated', 'success');
      this.authService.userRoleChanged.emit(true);
      if (event === CHANGE_TRIAL_ROLES[1].value) {
        this.router.navigateByUrl('/test-quizzes/classroom-details/teacher-classroom/true');
      } else if (event === CHANGE_TRIAL_ROLES[0].value) {
        this.router.navigateByUrl('dashboard/admin-dashboard');
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async updateUserLoginStatus(currentLocalUser) {
    const userBody = {
      ...currentLocalUser.user,
      is_logged_in: false,
    };
    await this.authService.updateUser(currentLocalUser?.user?.id, userBody, false);
  }

  async startAssessmentByUsingSocketEvent(assessment) {
    try {
      const user = this.storageService.getItem('user');
      if (user?.user?.role_id === ROLES.STUDENT) {
        const student = await this.studentService.getStudentByUserId({});
        this.dialog.closeAll();

        if (student[0]['classroom_id'].includes(assessment?.classroom?.code) && !this.getCurrentOnGoingAssessment()) {
          this.currentAssessment = assessment;

          const response = await this.studentService.checkStudentSubmittedAssignment({
            user_id: user.user.id,
            teacher_assesment_id: assessment?.id,
          });

          if (response !== true) {
            this.dialog.open(this.startAssessment, {
              disableClose: true,
              width: '500px',
              maxWidth: '95vw',
              panelClass: 'custom-dialog-container',
            });

            STUDENT_MENU_ITEMS.forEach((x) => {
              x.group = true;
            });
            this.sidebarService.collapse('menu-sidebar');
          }
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async updateUserLogOutSessionTime(userId: number): Promise<void> {
    try {
      const body = {
        date: new Date().setHours(0, 0, 0, 0),
      };
      const response: any = await this.authService.getUserTimeSession(body);
      if (response && response.length > 0) {
        response[0].sessions[response[0]?.sessions?.length - 1].endTime = new Date().getTime();
        body['sessions'] = response[0].sessions;
        await this.authService.updateUserTimeSession(response[0].id, body);
      }
    } catch (error) {
      // console.log(error);
    }
  }

  navigateHeader(url: string) {
    if (this.user.role_id === ROLES.STUDENT && this.getCurrentOnGoingAssessment()) {
      this.toasterService.showToast('Please finish the ongoing assessment first', 'danger');
      return;
    } else {
      if (this.user.role_id === ROLES.STUDENT && this.user.school.schoolData.isStudentMessageAccess === false) {
        this.toasterService.showToast('Admin has disabled contact/messaging for you', 'info');
        return;
      } else {
        this.analyticsService?.trackEvent(`Link Rendered`, 'Header');
        this.router.navigateByUrl(url);
      }
    }
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    if (this.user.role_id === ROLES.STUDENT && this.getCurrentOnGoingAssessment()) {
      this.toasterService.showToast('Please finish the ongoing assessment first', 'danger');
      return;
    }
    this.analyticsService?.trackEvent('Sidebar Toggle', 'Header');
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();
    this.openSidebar = !this.openSidebar;
    this.authService.sideBarOpen.emit(this.openSidebar);
    return false;
  }

  getCurrentOnGoingAssessment() {
    return this.storageService.getItem('currentOnGoingAssessment');
  }

  navigateHome() {
    if (this.user.role_id === ROLES.STUDENT && this.getCurrentOnGoingAssessment()) {
      this.toasterService.showToast('Please finish the ongoing assessment first', 'danger');
      return;
    }

    this.analyticsService?.trackEvent('Render to Home', 'Header Logo');
    this.menuService.navigateHome();
  }

  async getNotifications() {
    try {
      if (this.mockData) {
        this.notifications = NOTIFICATIONS.slice(0, 5);
        this.checkForUnreadClimateSurvey(NOTIFICATIONS);
        return;
      }

      if (this.user?.id) {
        const params = {
          user_id: this.user?.id,
        };
        const response: any = await this.notificationService.getNotificationsByUserId(params);

        this.notifications = response?.items.slice(0, 5);
        this.unreadNotifications = response.items.filter((n) => !n.read_status);

        this.checkForUnreadClimateSurvey(response.items);

        this.updateNotifications();
        this.setCurrentNotifyStatus();
      }
    } catch (error) {
      console.error('Notification fetch error:', error);
    }
  }

  checkForUnreadClimateSurvey(notifications: any[]): void {
    const unreadClimateSurveyList = notifications.filter(
      (notif) => notif.table_reference === 'climate_survey' && notif.read_status === false,
    );
    this.badgeVisible = unreadClimateSurveyList.length > 0;
  }

  setCurrentNotifyStatus() {
    const getCurrentNotifyStatus = this.storageService.getItem('isUnreadNotifications');
    if (getCurrentNotifyStatus !== null || getCurrentNotifyStatus !== undefined) {
      this.storageService.isBadge = getCurrentNotifyStatus;
      return;
    }

    const currentStatus = this.unreadNotifications.length > 0 ? true : false;
    this.storageService.isBadge = currentStatus;
    this.storageService.setItem('isUnreadNotifications', currentStatus);
  }

  updateNotifications() {
    try {
      return this.notifications.map((notification) => {
        notification.created_at =
          typeof notification.created_at !== 'string'
            ? dayjs(notification.created_at).fromNow()
            : notification.created_at;

        return notification;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async updateMultipleNotifications() {
    try {
      // Mock notification
      if (this.mockData) {
        this.toasterService.showToast(
          'From here, you will be able change all of the notifications status as a read.',
          'success',
        );
        return;
      }

      const body = {
        user_id: this.user?.id,
      };
      const res = await this.notificationService.updateMultipleNotifications(body);
    } catch (error) {
      // console.log(error);
    }
  }

  public renderToTakeAssessment(): void {
    try {
      this.storageService.setItem('currentOnGoingAssessment', this.currentAssessment?.id);
      this.router.navigate(['/test-quizzes/assessment', this.currentAssessment?.id]);
    } catch (error) {
      // console.log(error)
    }
  }

  private async getUserStatus(): Promise<void> {
    try {
      const response: any = await this.authService.userById(this.user.id);
      const userStatus: any = response?.user_activity_status;

      if (userStatus) {
        // Update the indicator based on the fetched status
        this.updateStatusIndicator(userStatus);
        // Set previousActivityStatus to avoid redundant updates on initialization
        this.previousActivityStatus = userStatus;
      }
    } catch (error) {
      console.error('Error fetching user status:', error);
    }
  }

  // Track inactivity and send status to DB
  private async inactivityTime(): Promise<void> {
    const resetTimer = () => {
      clearTimeout(this.timeout);
      this.lastActivity = new Date();
      if (!this.isLoggedOut) {
        this.updateUserStatus(UserActivityStatus.ACTIVE);
      }
      this.timeout = setTimeout(() => this.logInactive(), 3600000); // 1 hour
    };

    setTimeout(() => {
      resetTimer();
    }, 4000);
    // Register events for tracking activity
    window.onload = resetTimer;
    document.onclick = resetTimer;
    document.onkeydown = resetTimer;
  }

  private checkUserStatus(): void {
    const now = new Date();
    if (this.lastActivity) {
      const timeDiff = (now.getTime() - this.lastActivity.getTime()) / (1000 * 60 * 60); // in hours
      if (timeDiff >= 24) {
        this.updateUserStatus(UserActivityStatus.LOGGED_OUT);
      } else if (timeDiff >= 1) {
        this.updateUserStatus(UserActivityStatus.INACTIVE);
      } else {
        this.updateUserStatus(UserActivityStatus.ACTIVE);
      }
    }
  }

  // private checkUserStatus(): void {
  //   const now = new Date();
  //   if (this.lastActivity) {
  //     const timeDiff = (now.getTime() - this.lastActivity.getTime()) / 1000; // in seconds for testing

  //     // Set time thresholds for testing purposes
  //     if (timeDiff >= 24 * 60 * 60) { // 24 hours in seconds
  //       this.updateUserStatus(UserActivityStatus.LOGGED_OUT);
  //     } else if (timeDiff >= 30) { // 30 seconds for testing
  //       this.updateUserStatus(UserActivityStatus.INACTIVE);
  //     } else {
  //       this.updateUserStatus(UserActivityStatus.ACTIVE);
  //     }
  //   }
  // }

  private logInactive(): void {
    if (!this.isLoggedOut) {
      this.updateUserStatus(UserActivityStatus.INACTIVE);
    }
  }

  private updateStatusIndicator(status: UserActivityStatus): void {
    const statusIndicator = document.getElementById('status-indicator');
    if (statusIndicator) {
      statusIndicator.className = ''; // Clear existing status classes
      statusIndicator.classList.add('dot'); // Common dot class for styling

      if (status === UserActivityStatus.ACTIVE) {
        statusIndicator.classList.add('status-green');
      } else if (status === UserActivityStatus.INACTIVE) {
        statusIndicator.classList.add('status-yellow');
      } else if (status === UserActivityStatus.LOGGED_OUT) {
        statusIndicator.classList.add('status-red');
      }
    }
  }

  public async updateUserStatus(status: UserActivityStatus) {
    if (status !== this.previousActivityStatus) {
      // Update the status indicator
      this.updateStatusIndicator(status);

      // Update the previous status to the current status
      this.previousActivityStatus = status;
      // Send the status update to the server
      try {
        await this.authService.updateActivityStatus({
          user_id: this.user.id,
          user_activity_status: status,
        });
      } catch (error) {
        console.error('Error updating user status:', error);
      }
    } else {
      // console.warn('Status is the same as the previous status');
    }
  }

  ngOnDestroy(): void {
    this.socket.disconnect();
    this.socket.close();
    this.previousActivityStatus = '';
    if (this.statusCheckSubscription) {
      this.statusCheckSubscription.unsubscribe();
    }
  }
}
